import { createAsyncThunk } from '@reduxjs/toolkit';
import { Article } from '@wix/answers-api';

import { fedopsLogger } from '../../util/renderModel';
import { getArticleById } from '../api/getArticleById';
import { HttpClientFactory } from '../httpClient';
import { TRootState } from '../reducers';
import { ErrorStatus } from '../reducers/types';

export const loadArticlePreview = createAsyncThunk<
  Article,
  { id: string; httpClient: HttpClientFactory },
  { state: TRootState; rejectValue: ErrorStatus }
>('loadArticleById', async ({ id, httpClient }, { rejectWithValue }) => {
  try {
    fedopsLogger.interactionStarted('fetching-article');
    return await getArticleById(id, httpClient);
  } catch (error) {
    return rejectWithValue(error.response?.status);
  } finally {
    fedopsLogger.interactionEnded('fetching-article');
  }
});
